import React, {useState, useEffect} from 'react';
import { useFormContext } from 'react-hook-form';
import { FormLabel, Tooltip, DatePicker, DatePickerInput} from 'carbon-components-react';

const FormDatePicker = ({label, name, helperText, maxDate, minDate, tooltipContent, disabled, onChange, props}) => {
    const {register, formState, watch, setValue, trigger} = useFormContext(); 
    let obj = formState.errors[name];
    const [dateValue, setDateValue] = useState(null);
    const date = watch(name);


    const array = name.substr(0, name.indexOf("["));
    if(array.length > 0){
        const optionalName = name.replace('.', '?.');
        obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
    }
    useEffect(() => {
        setDateValue(date);
    }, [date]);

    const formatDate = (value) => {
        return value.match(/\d*/g).join('')
        .match(/(\d{0,2})(\d{0,2})(\d{0,4})/).slice(1).join('/')
        .replace(/\/*$/g, '');
    }

    const change = (e) => {
        if(onChange)
            onChange(e);

        setValue(name, e);
        trigger(name);
    }
    const inputChange = (e) => {
        e.target.value = formatDate(e.target.value);
    }

    return ( 
        <>
        <FormLabel>
            {
            tooltipContent ?
            <Tooltip triggerText={label}>
                {tooltipContent}
            </Tooltip> 
            : <>{label}</>
            }
        </FormLabel>
        <DatePicker
            datePickerType="single" 
            dateFormat="m/d/Y" 
            {...register(name)}
            value={dateValue}
            onChange={change}
            maxDate={maxDate}
            minDate={minDate}
            >
            <DatePickerInput  id={`date-${name}`} className="mb-6" 
             invalidText={obj?.message} 
                placeholder="mm/dd/yyyy"
                invalid={!!obj} 
                helperText={helperText} 
                disabled={disabled} 
                hideLabel={true}
                labelText={label}
                onChange = {inputChange}
                {...props} />
        </DatePicker>
        </>
     );
}
 
export default FormDatePicker;